import type { SVGProps } from 'react'

import { Wrapper } from './Wrapper'

export const IconHeaderError = (props: SVGProps<SVGSVGElement>) => (
	<Wrapper>
		<svg width='200' height='200' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			<path
				d='M72.3248 43.4L67.1498 57.5V68.1417C67.0275 70.4347 65.8126 72.5299 63.8832 73.775L47.2165 83.2583L39.1665 92.6583L34.0415 89.675C33.3276 89.1958 32.9492 88.3517 33.0665 87.5L33.1415 59.8083L38.7998 63.1417L44.4915 53.3333L50.1498 56.6667L55.8332 46.8917L61.4832 50.225L67.1832 40.425L72.3248 43.4Z'
				fill='#666666'
			/>
			<path
				d='M66.6664 53.2L61.0081 49.8667L55.2831 59.675L49.6247 56.3417L43.9247 66.1417L38.2664 62.8083L38.1914 90.5C38.1914 92.5833 39.6497 93.4417 41.4497 92.4167L68.9497 76.725C70.8813 75.4808 72.0992 73.3859 72.2247 71.0917L72.2997 43.3917L66.6664 53.2Z'
				fill='#D5D5D5'
			/>
			<path
				d='M54.425 11.3667C53.6793 11.0289 52.8105 11.1113 52.1416 11.5833L24.6416 27.275C22.6981 28.5163 21.4677 30.6144 21.3333 32.9167L21.2583 60.15L16.1333 57.175L16.2083 29.9333C16.3312 27.6361 17.5494 25.5376 19.4833 24.2917L46.9833 8.60833C47.6438 8.14174 48.4997 8.0533 49.2416 8.375L54.425 11.3667Z'
				fill='#666666'
			/>
			<path
				d='M24.6081 27.275L52.1081 11.5833C52.777 11.1113 53.6458 11.0289 54.3915 11.3667C55.0773 11.8494 55.4474 12.6661 55.3581 13.5L55.2831 41.1917L49.6248 50.9917L44.5081 47.9833L43.9665 47.6667L38.2665 57.5L33.1581 54.4917L32.6081 54.1667L27.1331 63.5667L21.2998 60.15L21.3331 32.9167C21.4601 30.6207 22.6773 28.5238 24.6081 27.275Z'
				fill='#3399FF'
			/>
			<path
				d='M21.3083 42.175L21.2583 60.15L27.1333 63.5667L32.6 54.1667L32.6083 54.1334L33.1583 54.4584L38.2666 57.4667L43.95 47.6917L43.9666 47.6667L44.5083 47.9834L49.625 50.9917L55.3166 41.1917L55.3666 22.5084L21.3083 42.175Z'
				fill='#D5D5D5'
			/>
			<path
				opacity='0.5'
				d='M21.4585 31.85L16.3252 28.8666C16.5938 27.6769 17.1423 26.5685 17.9252 25.6333L23.0585 28.6166C22.2756 29.5518 21.7271 30.6603 21.4585 31.85Z'
				fill='#C9C7C7'
			/>
			<path
				opacity='0.5'
				d='M24.6084 27.275L19.4834 24.3L20.8334 23.5084L25.9667 26.4917L24.6084 27.275Z'
				fill='#C9C7C7'
			/>
			<path
				opacity='0.5'
				d='M21.3252 35.9166L16.2002 32.9333V31.3333L21.3335 34.3166L21.3252 35.9166Z'
				fill='#C9C7C7'
			/>
			<path
				d='M62.85 27.7167H62.7C62.2499 27.6323 61.9522 27.2007 62.0333 26.75L63.525 18.4167C63.6055 17.9564 64.0439 17.6486 64.5042 17.7292C64.9644 17.8097 65.2722 18.2481 65.1917 18.7083L63.6667 27.025C63.598 27.423 63.2539 27.7145 62.85 27.7167Z'
				fill='#C9C7C7'
			/>
			<path
				d='M71.1414 32.2667C70.9809 32.2638 70.8246 32.2146 70.6914 32.125C70.3054 31.8761 70.1935 31.3617 70.4414 30.975L75.0747 23.8417C75.237 23.5916 75.5203 23.4471 75.818 23.4626C76.1158 23.478 76.3826 23.6512 76.518 23.9167C76.6535 24.1823 76.637 24.4999 76.4747 24.75L71.8414 31.8834C71.6884 32.1218 71.4247 32.2662 71.1414 32.2667Z'
				fill='#C9C7C7'
			/>
			<path
				d='M76.4166 40.425C76.0453 40.4225 75.7205 40.1746 75.62 39.8172C75.5196 39.4597 75.6677 39.0789 75.9833 38.8833L83.2416 34.4417C83.4952 34.2288 83.8507 34.1862 84.1473 34.3332C84.444 34.4801 84.6255 34.7887 84.6098 35.1194C84.5941 35.4501 84.3842 35.7401 84.075 35.8583L76.8166 40.3C76.6961 40.3751 76.5585 40.4181 76.4166 40.425Z'
				fill='#C9C7C7'
			/>
			<ellipse
				cx='50.3534'
				cy='19.3021'
				rx='3.725'
				ry='2.15833'
				transform='rotate(-59.84 50.3534 19.3021)'
				fill='#C9C7C7'
			/>
			<ellipse
				cx='43.4115'
				cy='23.3149'
				rx='3.725'
				ry='2.15833'
				transform='rotate(-59.84 43.4115 23.3149)'
				fill='#C9C7C7'
			/>
		</svg>
	</Wrapper>
)
